import axios from 'axios';

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

// Attach Bearer token if present in localStorage (fallback when 3rd-party cookies blocked)
api.interceptors.request.use((config) => {
  const t = localStorage.getItem('agn_token');
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || 'Errore imprevisto';
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) return d.map(e => e?.msg || JSON.stringify(e)).join(' · ');
  if (typeof d === 'object' && d.msg) return d.msg;
  return String(d);
}

export function imgUrl(fileIdOrUrl) {
  if (!fileIdOrUrl) return null;
  if (fileIdOrUrl.startsWith('http')) return fileIdOrUrl;
  if (fileIdOrUrl.startsWith('/api/')) return `${BACKEND_URL}${fileIdOrUrl}`;
  return `${API_BASE}/files/${fileIdOrUrl}`;
}
